import { useEffect } from 'react';

type UseHashNavigationOptions = {
  hash?: string;
  onNavigate?: (hash: string) => void;
};

export const useHashNavigation = ({ hash, onNavigate }: UseHashNavigationOptions) => {
  useEffect(() => {
    if (hash) {
      window.location.hash = hash;
    }

    const handleHashChange = () => {
      const currentHash = window.location.hash;
      if (onNavigate) {
        onNavigate(currentHash);
      }
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [hash, onNavigate]);
};
